import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import './RealEstate.css';
import { Link } from 'react-router-dom';

function RealEstate() {
  const [selectedImage, setSelectedImage] = useState(null);
  const images = [
    { src: "/images/hotelshooting-8.jpg", alt: "Real Estate 1" },
    { src: "/images/hotelshooting-17.jpg", alt: "Real Estate 2" },
    { src: "/images/hotelshooting-16.jpg", alt: "Real Estate 3" },
    { src: "/images/hotelshooting-15.jpg", alt: "Real Estate 4" },
    { src: "/images/hotelshooting-14.jpg", alt: "Real Estate 5" },
    { src: "/images/hotelshooting-13.jpg", alt: "Real Estate 6" },
    { src: "/images/hotelshooting-12.jpg", alt: "Real Estate 7" },
    { src: "/images/hotelshooting-9.jpg", alt: "Real Estate 8" },
    { src: "/images/hotelshooting-10.jpg", alt: "Real Estate 9" },
    { src: "/images/hotelshooting-11.jpg", alt: "Real Estate 10" },
    { src: "/images/hotelshooting.jpg", alt: "Real Estate 11" }
  ];

  const handleImageClick = (index) => {
    setSelectedImage(index);
  };

  const handleCloseModal = () => {
    setSelectedImage(null);
  };

  const handlePrevImage = () => {
    setSelectedImage((prevIndex) => (prevIndex === 0 ? images.length - 1 : prevIndex - 1));
  };

  const handleNextImage = () => {
    setSelectedImage((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
  };

  useEffect(() => {
    if (selectedImage === null) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') handleCloseModal();
      if (e.key === 'ArrowRight') handleNextImage();
      if (e.key === 'ArrowLeft') handlePrevImage();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedImage, images]);

  return (
    <div className="realestate-section">
      <Helmet>
        <title>Real Estate Photography in Bristol | Property Photography Services</title>
        <meta name="description" content="Professional real estate photography services in Bristol. High-quality property photos for estate agents, developers, and property listings across South West UK." />
        <meta name="keywords" content="real estate photography, property photography, Bristol property photographer, architectural photography, South West UK real estate" />
        <meta property="og:title" content="Real Estate Photography in Bristol | Property Photography Services" />
        <meta property="og:description" content="Professional real estate photography services in Bristol. High-quality property photos for estate agents and property listings." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://szakacsvisuals.co.uk/services/real-estate" />
        <link rel="canonical" href="https://szakacsvisuals.co.uk/services/real-estate" />
      </Helmet>
      <div className="header-img-container">
        <img className="header-img" src="/images/hotelshooting-8.jpg" alt="Real Estate header" />
        <div className="header-img-overlay">
          <h1 className="header-title-mobile">Real Estate</h1>
          <p>Showcase your properties with our professional real estate photography services.</p>
        </div>
      </div>
      <h1 style={{display:'none'}}>Real Estate</h1>
      <p style={{display:'none'}}>Professional real estate photography to highlight your properties.</p>
      <div className="gallery-grid-realestate">
        {images.map((image, index) => (
          <img key={index} className="gallery-img" src={image.src} alt={image.alt} onClick={() => handleImageClick(index)} />
        ))}
      </div>
      {selectedImage !== null && (
        <div className="album-modal-overlay" onClick={handleCloseModal}>
          <div className="album-modal" onClick={(e) => e.stopPropagation()}>
            <button className="album-close-btn" onClick={handleCloseModal}>&times;</button>
            <button className="album-arrow album-arrow-left" onClick={handlePrevImage}>&#8592;</button>
            <img className="album-image" src={images[selectedImage].src} alt={images[selectedImage].alt} />
            <button className="album-arrow album-arrow-right" onClick={handleNextImage}>&#8594;</button>
            <div className="album-indicators">
              {images.map((_, idx) => (
                <button
                  key={idx}
                  className={idx === selectedImage ? 'album-dot active' : 'album-dot'}
                  onClick={() => setSelectedImage(idx)}
                  aria-label={`Go to image ${idx + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      )}
      {/* Pricing Plan Section */}
      <div className="pricing-plan-section">
        <div className="pricing-plan-grid">
          <div className="pricing-card">
            <img className="pricing-card-img" src="/images/hotelshooting-8.jpg" alt="Real Estate Shoot" />
            <div className="pricing-card-title">Real Estate Shoot</div>
            <div className="pricing-card-details">1.5 hr</div>
            <div className="pricing-card-price">£100</div>
            <Link to="/contact" className="pricing-card-btn">Book Now</Link>
          </div>
          <div className="pricing-card premium">
            <div className="premium-badge">Most Popular</div>
            <img className="pricing-card-img" src="/images/hotelshooting.jpg" alt="Premium Package" />
            <div className="pricing-card-title">Premium Package</div>
            <div className="pricing-card-details">Photos + Video</div>
            <div className="pricing-card-price">£150</div>
            <Link to="/contact" className="pricing-card-btn premium-btn">Book Now</Link>
          </div>
          <div className="pricing-card">
            <img className="pricing-card-img" src="/images/hotelshooting-15.jpg" alt="Real Estate Walkthrough Video" />
            <div className="pricing-card-title">Real Estate Walkthrough Video</div>
            <div className="pricing-card-details">1.5 hr</div>
            <div className="pricing-card-price">£100</div>
            <Link to="/contact" className="pricing-card-btn">Book Now</Link>
          </div>
        </div>
      </div>
      <div className="gallery-cta">
        <h1>Real Estate Photography & Video Services in Bristol, Wales & the South West</h1>
        <p>Showcase your property with professional real estate photography and cinematic walkthrough videos. Based in Bristol and serving Wales, Somerset, Gloucestershire, and the wider South West UK, we work with estate agents, landlords, and property developers to create striking visual content that helps properties sell faster.
        From crisp interior and exterior photos to smooth, engaging video tours and social media-ready clips, we capture every detail to highlight what makes your listing unique. Whether it's a flat in Cardiff, a townhouse in Bath, or a commercial space in Bristol, we bring out the best in every property.</p>

        <Link to="/contact" className="gallery-cta-btn">Book Now</Link>
      </div>
    </div>
  );
}

export default RealEstate; 